import React from 'react'
import { FormattedMessage } from 'react-intl'
import { LoginForm } from 'app/sofia/components/LoginForm'
import { PublicLayout, Title } from '../../../../components/Styled'

export const Login = () => {
  return (
    <PublicLayout>
      <div>
        <Title>
          <FormattedMessage
            id='customer.account.login.title'
          />
        </Title>
        <LoginForm
          shouldRedirectToAccount
        />
      </div>
    </PublicLayout>
  )
}
